
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');
require('../../node_modules/bootstrap-submenu/dist/js/bootstrap-submenu.min.js');
require('../../node_modules/slick-carousel/slick/slick.min.js');
require('../../node_modules/magnific-popup/dist/jquery.magnific-popup.js');
require('../../node_modules/@fancyapps/fancybox/dist/jquery.fancybox.min.js');
// Assegno la baseurl
window.base_url = process.env.MIX_BASE_URL;
// Imports
import VueLodash from 'vue-lodash';
import lodash from 'lodash';
import vmodal from 'vue-js-modal';
import Adsense from 'vue-google-adsense/dist/Adsense.min.js';
import InArticleAdsense from 'vue-google-adsense/dist/InArticleAdsense.min.js';
import InFeedAdsense from 'vue-google-adsense/dist/InFeedAdsense.min.js';
import WOW from 'wow.js';
import VueToasted from 'vue-toasted';
import * as VueGoogleMaps from 'vue2-google-maps';
import Swal from 'sweetalert2';
// Inizializzo WOW
const wow = new WOW({
    boxClass: 'wow',
    animateClass: 'animated',
    offset: 0,
    live: true
});

wow.init();

// Creo la main instance di vue
window.Vue = require('vue');

// Vue use necessari
Vue.use(VueLodash, { name: 'loadsh' , lodash: lodash });
Vue.use(require('vue-script2'));
Vue.use(vmodal);
Vue.use(Adsense);
Vue.use(InArticleAdsense);
Vue.use(InFeedAdsense);
Vue.use(VueToasted, { iconPack: 'custom-class' });
Vue.use(VueGoogleMaps);

import * as Sentry from "@sentry/vue";
import { CaptureConsole } from "@sentry/integrations";

Sentry.init({
  Vue,
  trackComponents: true,
  environment: process.env.MIX_APP_ENV,
  // Disabilitato temporaneamente
  enabled: false, // process.env.MIX_APP_ENV !== 'local',
  dsn: process.env.MIX_SENTRY_DSN,
  integrations: [
    new Sentry.BrowserTracing(),
    new CaptureConsole({
        levels: ['error']
    })
  ],
});


// Require di tutti i componenti in lazy
require('./components');
// Componente root di Vue
require('./render');